/* mazo-clarity-events.js (2026-10-22, owner: "smart events show only 4 product views out of 513 sessions").
   Clarity's automatic Shopify smart events miss most product views on mazo's own product page (191 product page sessions in 3 days, 3 counted).
   So the site names its own events with clarity('event', name). They appear in Clarity > Settings > Smart events > Custom events and in the recording filters.
   Names only, no personal data, no new network request (the Clarity tag is already on the page). If Clarity is not loaded, or this is a team device, nothing happens.
   Events: product_view (once per product page), size_selected, size_chart_open, add_to_cart_click, checkout_click, sale_banner_click, sale_tab_seen.
   Also tags the session with the product handle and whether the sale is on, so a recording filter can say "sale sessions". */
(function () {
  'use strict';
  if (window.__mazoClarityEvents) return;
  window.__mazoClarityEvents = true;
  function c() {
    if (typeof window.clarity !== 'function') {
      window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    }
    try { window.clarity.apply(null, arguments); } catch (e) {}
  }
  var lastEv = {};
  function ev(name) { var now = Date.now(); if (lastEv[name] && now - lastEv[name] < 800) return; lastEv[name] = now; c('event', name); }   /* the same event twice within 0.8 s is one */
  var once = {};
  function first(name) { if (once[name]) return; once[name] = 1; ev(name); }

  var path = location.pathname;
  var handle = (path.match(/\/products\/([^/?#]+)/) || [])[1];
  if (handle) { first('product_view'); c('set', 'product', handle); }
  /* 2026-10-23 (owner: "hashed customer Id, do it"): for a logged in shopper only, tell Clarity a one way hash of the Shopify customer id
     (SHA-256 of "mazo:" + id, first 16 hex characters). Never the name, email or phone. It lets a recording be matched to a customer in Shopify
     by hashing the same id there (python3 scripts/clarity_customer_hash.py <customer id>), and groups one person's sessions. */
  var cidMeta = document.querySelector('meta[name="mazo-cid"]');
  if (cidMeta && cidMeta.content && window.crypto && crypto.subtle && window.TextEncoder) {
    crypto.subtle.digest('SHA-256', new TextEncoder().encode('mazo:' + cidMeta.content)).then(function (buf) {
      var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 16);
      c('identify', hex, undefined, undefined, 'customer-' + hex.slice(0, 6));
    }).catch(function () {});
  }
  var saleOn = !!document.querySelector('.mazo-pricing-offer, [data-mazo-salebar]');
  if (saleOn) c('set', 'sale', 'on');

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.mazo-diwali__cta, [data-mazo-salebar] a')) ev('sale_banner_click');
    if (t.closest('.mazo-whatsmysize-wrap, [data-modal*="MazoSizeChart"]')) first('size_chart_open');
    if (t.closest('.product-form__input input[type="radio"], .product-form__input label, fieldset.product-form__input')) first('size_selected');
    if (t.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"]')) ev('checkout_click');
  }, true);

  /* Add to bag: listen on the product form's submit (Dawn handles the click itself and stops it, so a click listener on the document never saw it) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) ev('add_to_cart_click');
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.product-form__submit, button[name="add"]');
    if (b && !b.disabled) { clearTimeout(window.__mzAtc); window.__mzAtc = setTimeout(function () { ev('add_to_cart_click'); }, 0); }
  }, false);

  if ('IntersectionObserver' in window) {
    var tab = document.querySelector('.product .mazo-offer-tab, .mazo-pricing-offer .mazo-offer-tab');
    if (tab) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { first('sale_tab_seen'); io.disconnect(); } }); }, { threshold: 0.6 });
      io.observe(tab);
    }
  }
})();
